import {
  DateRangeIntervalWithoutWeek,
  StrictDateRange,
} from 'shared/types/analytics';

export interface GetChart<T> {
  series: T;
  loading: boolean;
  /** Requests the chart when its request changed (or always, with `forceUpdate`). */
  load: (forceUpdate?: boolean) => void;
  reload: () => void;
  updatedAt: number;
}

export enum RewriteFiltersActionEnum {
  rewriteFilters = 'REWRITE_FILTERS',
}
export enum FilterActionType {
  setDateRange = 'SET_DATE_RANGE',
  setProcesses = 'SET_PROCESSES',
  setSites = 'SET_SITES',
  setManagers = 'SET_MANAGERS',
}
export enum FilterActionTypeInterval {
  setDateInterval = 'SET_DATE_INTERVAL',
}
export interface RewriteFiltersAction<TFilters> {
  type: RewriteFiltersActionEnum.rewriteFilters;
  payload: TFilters;
}
export interface SetDateRangeAction {
  type: FilterActionType.setDateRange;
  payload: StrictDateRange;
}
export interface SetProcessesAction {
  type: FilterActionType.setProcesses;
  payload: string[];
}
export interface SetSitesAction {
  type: FilterActionType.setSites;
  payload: string[];
}
export interface SetManagersAction {
  type: FilterActionType.setManagers;
  payload: string[];
}
export interface SetDateIntervalAction {
  type: FilterActionTypeInterval.setDateInterval;
  payload: DateRangeIntervalWithoutWeek;
}
